import { render, staticRenderFns } from "./MeterSerialNumber.vue?vue&type=template&id=4899390f&"
import script from "./MeterSerialNumber.vue?vue&type=script&lang=ts&"
export * from "./MeterSerialNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports